/**
 * @generated SignedSource<<c224fdfe12bb39649544ff878b0defdc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoDetailToolbar_todo$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TVTodoPopovers_todo" | "TodoToolbarEdit_todo">;
  readonly " $fragmentType": "TodoDetailToolbar_todo";
};
export type TodoDetailToolbar_todo$key = {
  readonly " $data"?: TodoDetailToolbar_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoDetailToolbar_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoDetailToolbar_todo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoToolbarEdit_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TVTodoPopovers_todo"
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "a6d55deb8c903153194a2c4b5730714a";

export default node;
